// src/componentes/Dashboard/ReporteEjecutivoBanner.jsx
//
// Tile que muestra el último reporte ejecutivo diario generado por
// la scheduled function `reporteEjecutivoDiario`. Se auto-oculta si no
// hay reporte aún.

import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import { db } from "../../Firebase/firebaseconfig";
import "./ReporteEjecutivoBanner.css";

const ReporteEjecutivoBanner = () => {
  const [reporte, setReporte] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandido, setExpandido] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const q = query(
          collection(db, "reportes_ejecutivos"),
          orderBy("fechaMs", "desc"),
          limit(1),
        );
        const snap = await getDocs(q);
        if (!alive) return;
        if (!snap.empty) {
          setReporte({ id: snap.docs[0].id, ...snap.docs[0].data() });
        }
      } catch (e) {
        console.warn("Error cargando reporte ejecutivo:", e?.message);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (loading || !reporte) return null;

  const delta = Number(reporte.deltaSaldoAtrasado || 0);
  const deltaCasos = Number(reporte.deltaCasos || 0);
  const fmtMoney = (n) =>
    Number(n || 0).toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  return (
    <section className="rep-ej-banner">
      <header className="rep-ej-header" onClick={() => setExpandido(!expandido)}>
        <div>
          <h3>🤖 Reporte ejecutivo diario · {reporte.fechaISO}</h3>
          <div className="rep-ej-kpis">
            <span className={delta >= 0 ? "rep-ej-up" : "rep-ej-down"}>
              {delta >= 0 ? "▲" : "▼"} {fmtMoney(Math.abs(delta))} saldo atrasado
            </span>
            <span className="rep-ej-sep">·</span>
            <span>{reporte.totales?.totalCasos || 0} casos</span>
            {deltaCasos !== 0 && (
              <span className={deltaCasos > 0 ? "rep-ej-up" : "rep-ej-down"}>
                ({deltaCasos > 0 ? "+" : ""}
                {deltaCasos})
              </span>
            )}
            {reporte.promesasIncumplidas > 0 && (
              <>
                <span className="rep-ej-sep">·</span>
                <span className="rep-ej-down">
                  {reporte.promesasIncumplidas} promesas incumplidas
                </span>
              </>
            )}
          </div>
        </div>
        <button className="rep-ej-toggle">
          {expandido ? "▲ Ocultar" : "▼ Ver resumen IA"}
        </button>
      </header>

      {expandido && (
        <div className="rep-ej-body">
          <pre className="rep-ej-resumen">{reporte.resumenIA}</pre>
        </div>
      )}
    </section>
  );
};

export default ReporteEjecutivoBanner;
